const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const projectsHost = publicConfig.external_address;

const Projects = {
  fetchById: (projectID, token, callback) => {
    const params = {
      host: projectsHost,
      method: 'GET',
      path: `/v1/projects/${projectID}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  fetchAttachmentsByProjectID: (projectID, token, callback) => {
    const params = {
      host: projectsHost,
      method: 'GET',
      path: `/v1/projects/${projectID}/attachments`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  deleteAttachmentsByProjectID: (attachmentID, token, callback) => {
    const params = {
      host: projectsHost,
      method: 'DELETE',
      path: `/v1/projects/attachments/${attachmentID}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  fetchByExternalID: (externalID, callback) => {
    const params = {
      host: projectsHost,
      method: 'GET',
      path: `/v1/projects/external_id/${externalID}`
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  fetchUserProjectDetails: (ssoid, token, callback) => {
    const params = {
      host: projectsHost,
      method: 'GET',
      path: `/v1/projects/attachments/collaborator/${ssoid}/details?limit=500&ns_count=FAV_BOARD`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  fetchFavBoardByUser (ssoid, query, token, callback) {
    const params = {
      host: projectsHost,
      method: 'GET',
      path: `/v1/projects/attachments/collaborator/${ssoid}/xr/fav_board?limit=500${query}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  fetchListingsByProjectId: (projectID, token, callback) => {
    const params = {
      host: projectsHost,
      method: 'GET',
      path: `/v1/projects/attachments?ns=FAV_BOARD&project_id=${projectID}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  fetchAttachmentDetails: (attachmentID, token, callback) => {
    const params = {
      host: projectsHost,
      method: 'GET',
      path: `/v1/projects/attachments/${attachmentID}/details`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  queryAttachments: (path, token, callback) => {
    const params = {
      host: projectsHost,
      method: 'GET',
      path: `/v1/projects/attachments?${path}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  updateById: (projectID, token, payload, callback) => {
    const params = {
      host: projectsHost,
      method: 'PUT',
      path: `/v1/projects/${projectID}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  deleteBoard: (projectID, token, callback) => {
    const params = {
      host: projectsHost,
      method: 'DELETE',
      path: `/v1/projects/${projectID}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  copyBoard: (projectID, token, callback) => {
    const params = {
      host: projectsHost,
      method: 'POST',
      path: `/v1/projects/${projectID}/copy`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  createProject: (token, payload, callback) => {
    const params = {
      host: projectsHost,
      method: 'POST',
      path: '/v1/projects/attachments',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  batchUpdate: (token, payload, callback) => {
    const params = {
      host: projectsHost,
      method: 'POST',
      path: '/v1/projects/attachments/batch',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  getInvites: (token, projectId, callback) => {
    const params = {
      host: projectsHost,
      method: 'GET',
      path: `/v1/projects/${projectId}/invite`
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  createInvites: (token, projectId, payload, callback) => {
    const params = {
      host: projectsHost,
      method: 'POST',
      path: `/v1/projects/${projectId}/invite`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  createAttachmentsByProjectID: (projectID, attachmentID, token, ns, projectInviteId, text, callback) => {
    const body = {
      project: `${projectID}`,
      value: `${attachmentID}`,
      ns: `${ns}`,
      project_invite_id: `${projectInviteId}`
    };

    if (text) {
      body.data = {};
      body.data.text = text;
    }

    const params = {
      host: projectsHost,
      method: 'POST',
      path: '/v1/projects/attachments',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, body);
  }
};

module.exports = Projects;
